import React, { useState, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Snackbar,
  Alert,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../../assets/styles/OrderDetails.css";
import axios from "axios";
import { OrderContext } from "../../contexts/OrderContext";
import { useDropzone } from "react-dropzone";
import { styled } from "@mui/system"; // For custom styling
import jsPDF from "jspdf";
import QRCode from "qrcode";
import { PDFDocument } from "pdf-lib";
import loadImage from "blueimp-load-image";
import DownloadIcon from "@mui/icons-material/Download";
import {
  generateJobcardReportPdf,
  buildQuickNoByType,
  entriesFromSavedItems,
} from "../../utils/jobcardReportPdf";
const OrderDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { order } = location.state || {};
  console.log(order);
  const [userDetails, setUserDetails] = useState(null);
  const userRole = localStorage.getItem("userRole");
  const token = localStorage.getItem("authToken");
  const { storeData, fetchOrders } = useContext(OrderContext);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [openModal, setOpenModal] = useState(false);
  const [editableOrder, setEditableOrder] = useState(order);
  const [jobcardItems, setJobcardItems] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(
    order?.work_status_id || "",
  );
  const [selectedKarigar, setSelectedKarigar] = useState(
    order?.karigar_id || "",
  );
  const [selectedItemTypeId, setselectedItemTypeId] = useState(
    order?.itemtype_id || "",
  );
  const [selectedDesignId, setselectedDesignId] = useState(
    order?.design_id || "",
  );
  const [selectedCustmerId, setselectedCustmerId] = useState(
    order?.customer_ref_no || "",
  );
  const [selectedScrewTypeId, setselectedScrewTypeId] = useState(
    order?.screw_type_id || "",
  );
  const [selectedFinishId, setselectedFinishId] = useState(
    order?.finishtype_id || "",
  );
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [completionStatus, setCompletionStatus] = useState("complete"); // Default value
  useEffect(() => {
    const selectedMfr = JSON.parse(localStorage.getItem("selectedMfr"));

    if (selectedMfr) {
      setUserDetails(selectedMfr);
    }
  }, []);

  useEffect(() => {
    if (order?.order_images) {
      try {
        const parsedImages = JSON.parse(order.order_images);
        setSelectedMedia(parsedImages);
        setSelectedImage(parsedImages[0]); // Set first image as default big image
      } catch (error) {
        console.error("Error parsing order images:", error);
      }
    }
  }, [order]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      const updatedImages = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      );

      setEditableOrder((prevData) => ({
        ...prevData,
        order_images: [...(prevData.order_images || []), ...updatedImages], // Append new files
      }));

      setSelectedMedia((prev) => [...prev, ...updatedImages]); // Update selected media state
    },
    accept: "image/*, video/*",
  });

  const handleSnackbarClose = () => {
    setSnackbar(false);
  };

  const handleEditOrder = () => {
    setOpenModal(true); // Open modal to edit order
  };

  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal
  };

  const handleSaveChanges = async () => {
    try {
      const formData = new FormData();

      formData.set(
        "work_status_id",
        selectedStatus
          ? Array.isArray(selectedStatus)
            ? selectedStatus[0]
            : selectedStatus
          : null,
      );
      formData.set(
        "karigar_id",
        selectedKarigar
          ? Array.isArray(selectedKarigar)
            ? selectedKarigar[0]
            : selectedKarigar
          : null,
      );
      formData.set(
        "itemtype_id",
        selectedItemTypeId
          ? Array.isArray(selectedItemTypeId)
            ? selectedItemTypeId[0]
            : selectedItemTypeId
          : null,
      );
      formData.set(
        "design_id",
        selectedDesignId
          ? Array.isArray(selectedDesignId)
            ? selectedDesignId[0]
            : selectedDesignId
          : null,
      );
      formData.set(
        "store_id",
        selectedCustmerId
          ? Array.isArray(selectedCustmerId)
            ? selectedCustmerId[0]
            : selectedCustmerId
          : null,
      );
      formData.set(
        "screw_type_id",
        selectedScrewTypeId
          ? Array.isArray(selectedScrewTypeId)
            ? selectedScrewTypeId[0]
            : selectedScrewTypeId
          : null,
      );
      formData.set(
        "finishtype_id",
        selectedFinishId
          ? Array.isArray(selectedFinishId)
            ? selectedFinishId[0]
            : selectedFinishId
          : null,
      );

      Object.keys(editableOrder).forEach((key) => {
        if (editableOrder[key] !== null && editableOrder[key] !== undefined) {
          if (Array.isArray(editableOrder[key])) {
            editableOrder[key].forEach((file) => {
              formData.append(key, file);
            });
          } else {
            formData.append(key, editableOrder[key]);
          }
        }
      });

      const token = localStorage.getItem("authToken"); // Fetch token from local storage

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/orders/updateorder`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log("Order updated successfully:", response.data);
      if (response.data) {
        await fetchOrders();
        await handleCloseModal();
        navigate("/home");
      }
    } catch (error) {
      console.error("Error saving changes:", error);
    }
  };

  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
    setImageModalOpen(true);
  };

  const handleCloseImageModal = () => {
    setImageModalOpen(false);
  };

  const handleAccept = () => {
    console.log("Order accepted:", order.orderid);
    handleUpdateStatus(4);
  };

  const handleComplete = () => {
    let statusId;
    if (completionStatus === "complete") {
      statusId = 5; // Or whatever your "complete" status ID is
    } else if (completionStatus === "partial") {
      statusId = 8; // Or whatever your "partial complete" status ID is
    } else if (completionStatus === "completewithoutqr") {
      statusId = 5;
      navigate("/completeorderwithoutqr", {
        state: { order: editableOrder, completionStatus: statusId },
      });
      return;
    } else {
      // Handle other cases or invalid selections if needed
      return; // Don't navigate if statusId is not set
    }

    navigate("/completeorder", {
      state: { order: editableOrder, completionStatus: statusId },
    }); // Pass completionStatus
  };

  const handleCompletionStatusChange = (event) => {
    setCompletionStatus(event.target.value);
  };

  // Load saved completion data once. Used to (a) show the Jobcard button ONLY
  // when a Final Save actually produced item/stone details, and (b) rebuild the
  // PDF without re-fetching.
  useEffect(() => {
    const loadJobcard = async () => {
      if (!order?.storeorderno) return;
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/fetchorder/fetchCompleteDetails/${order.storeorderno}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setJobcardItems(res.data?.data?.items || []);
      } catch (err) {
        setJobcardItems([]);
      }
    };
    loadJobcard();
  }, [order?.storeorderno]);

  // Re-open the voucher-style Jobcard for this order from the loaded data.
  const handleViewJobcard = () => {
    if (!jobcardItems.length) return;
    const storeName =
      JSON.parse(localStorage.getItem("selectedMfr"))?.storeDetails?.name ||
      order.store_name ||
      "";
    const karigarName =
      order.karigar_name ||
      JSON.parse(localStorage.getItem("user"))?.name ||
      "";
    generateJobcardReportPdf({
      orderNo: order.storeorderno,
      storeName,
      karigarName,
      entries: entriesFromSavedItems(jobcardItems),
      quickNoByType: buildQuickNoByType(storeData?.stone),
    });
  };

  const handleReject = () => {
    setRejectModalOpen(true);
  };

  const handleCloseRejectModal = () => {
    setRejectModalOpen(false);
    setRejectReason("");
  };

  const handleConfirmReject = async () => {
    if (!rejectReason.trim()) {
      setSnackbar({
        open: true,
        message: "Reason is required!",
        severity: "failure",
      });
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/orders/updateStatus`,
        {
          orderid: order.orderid,
          work_status_id: 7, // Status ID for "Rejected"
          reject_reason: rejectReason,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      console.log("Order rejected successfully:", response.data);
      setRejectModalOpen(false);
      setRejectReason("");
      setSnackbar({
        open: true,
        message: "Order status updated successfully!",
        severity: "success",
      });
      setTimeout(() => {
        fetchOrders();
        navigate("/home");
      }, 1474747);
    } catch (error) {
      console.error("Error rejecting order:", error);
      setSnackbar({
        open: true,
        message: "Order rejection failed!",
        severity: "failure",
      });
    }
  };

  const handleUpdateStatus = async (newStatus) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/orders/updateStatus`,
        {
          orderid: order.orderid,
          work_status_id: newStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      setSnackbar({
        open: true,
        message: "Order status updated successfully!",
        severity: "success",
      });
      setTimeout(() => {
        fetchOrders();
        navigate("/home");
      }, 1474747);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update order status.";
      setSnackbar({
        open: true,
        message: errorMessage,
        severity: "error",
      });
      console.error("Error updating order status:", error);
    }
  };

  const handleDownloadAll = async () => {
    try {
      for (const media of orderImages) {
        const fileName = media.split("/").pop(); // Extract file name from URL

        // Fetch the media file content
        const response = await fetch(media);
        const blob = await response.blob(); // Get the file as a Blob
        const url = window.URL.createObjectURL(blob); // Create a temporary URL for the Blob

        // Create a temporary anchor element to trigger the download in the background
        const link = document.createElement("a");
        link.href = url; // Set the href to the Blob URL
        link.download = fileName; // Set the filename for the download

        // Trigger the download in the background without affecting the UI
        document.body.appendChild(link); // Append the link to the DOM
        link.click(); // Click the link to start downloading the file
        document.body.removeChild(link); // Remove the link after triggering the download

        // Revoke the Blob URL after download to free memory
        window.URL.revokeObjectURL(url);
      }

      setSnackbar({
        open: true,
        message: "All media files are being downloaded in the background!",
        severity: "success",
      });
    } catch (error) {
      console.error("Error downloading media:", error);
      setSnackbar({
        open: true,
        message: "Failed to download media!",
        severity: "error",
      });
    }
  };

  const orderImages = order?.order_images
    ? JSON.parse(order.order_images) // Parse JSON string into an array
    : [];

  const StyledFormControl = styled(FormControl)({
    minWidth: 150,
    marginRight: "10px",
    marginTop: "10px", // Add top margin
    "& .MuiInputLabel-root": {
      color: "#555",
      fontSize: "0.875rem", // Adjust font size for smaller label
      top: "-5px", // Adjust label position
    },
    "& .MuiSelect-root": {
      border: "1px solid #ccc",
      borderRadius: "4px",
      padding: "6px 10px", // Reduce padding for height
      fontSize: "0.875rem", // Smaller font
      height: "42px", // Explicitly set height
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccc",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#aaa",
    },
  });

  const handleDrop = (acceptedFiles) => {
    const filesWithPreview = acceptedFiles.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      }),
    );

    const updatedImages = [...editableOrder.order_images, ...filesWithPreview];

    setEditableOrder((prev) => ({
      ...prev,
      order_images: updatedImages,
    }));

    if (!selectedMedia) {
      setSelectedMedia(filesWithPreview[0]);
    }
  };

  const handleDownloadPdf = async (order) => {
    const capitalizeFirst = (text) =>
      !text || typeof text !== "string"
        ? text
        : text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

    const formatDateToDDMMYYYY = (dateStr) => {
      if (!dateStr) return "N/A";
      const date = new Date(dateStr);
      if (isNaN(date)) return "Invalid Date";
      return `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1,
      ).padStart(2, "0")}-${date.getFullYear()}`;
    };

    const convertToCompressedBase64 = async (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const maxDim = 1000;
          let { width, height } = img;

          if (width > maxDim || height > maxDim) {
            const scale = Math.min(maxDim / width, maxDim / height);
            width = width * scale;
            height = height * scale;
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          const dataUrl = canvas.toDataURL("image/jpeg", 0.7);
          resolve(dataUrl);
        };
        img.onerror = reject;
        img.src = url;
      });
    };

    const isImageUrl = (url) =>
      ["jpg", "jpeg", "png", "gif", "webp"].some((ext) =>
        url.toLowerCase().includes(`.${ext}`),
      );
    const isPdfUrl = (url) => /\.pdf$/i.test(url);

    const fetchPdfBytes = async (url) => {
      const response = await fetch(url);
      return new Uint8Array(await response.arrayBuffer());
    };

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const headerHeight = 1;

    // doc.setFont("helvetica", "bold");
    // doc.setFontSize(20);
    // doc.text(order.store_name || "Store", pageWidth / 2, 12, {
    //   align: "center",
    // });

    // doc.setFontSize(11);
    // doc.setFont("helvetica", "normal");
    // doc.text("( JOBCARD ISSUE )", pageWidth / 2, 20, { align: "center" });

    // doc.setDrawColor(0);
    // doc.setLineWidth(0.3);
    // doc.line(0, headerHeight + 1, pageWidth, headerHeight + 1);

    let qrDataUrl = "";
    try {
      qrDataUrl = await QRCode.toDataURL(order.storeorderno || "", {
        errorCorrectionLevel: "H",
        margin: 1,
        width: 60,
      });
    } catch (err) {
      console.warn("QR generation failed", err);
    }

    let metaY = headerHeight + 10;
    const addLabelValue = (label, value) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.text(`${label}:`, 8, metaY);
      const labelWidth = doc.getTextWidth(`${label}:`);
      doc.setFont("helvetica", "normal");
      doc.text(`${value}`, 8 + labelWidth + 2, metaY);
      metaY += 6;
    };

    addLabelValue("Order No", order.storeorderno);
    addLabelValue("Order Date", formatDateToDDMMYYYY(order.orderdate));
    addLabelValue("Karigar", order.karigar_name);

    if (qrDataUrl) {
      const qrSize = 25;
      doc.addImage(
        qrDataUrl,
        "PNG",
        pageWidth - qrSize - 10,
        headerHeight + 4,
        qrSize,
        qrSize,
      );
    }

    const tableY = Math.max(metaY, headerHeight + 34);
    const tableBody = [
      [
        "Item",
        capitalizeFirst(order.itemtype_name),
        "Purity",
        order.purity,
        "",
        "",
      ],
      [
        "Design",
        capitalizeFirst(order.design_name),
        "PCS",
        order.pcs,
        "Size",
        order.size_len,
      ],
      ["Gross Wt", order.weight, "Net Wt", order.netwt, "", ""],
      ["Description", { content: order.description || "", colSpan: 5 }],
    ];
    doc.autoTable({
      startY: tableY,
      body: tableBody,
      theme: "grid",
      styles: { fontSize: 10, textColor: [40, 40, 40] },
      columnStyles: {
        0: { cellWidth: 27 },
        1: { cellWidth: 38 },
        2: { cellWidth: 27 },
        3: { cellWidth: 38 },
        4: { cellWidth: 27 },
        5: { cellWidth: 38 },
      },
      margin: { left: 5, right: 5 },
    });

    let contentY = doc.lastAutoTable.finalY + 10;

    // doc.setFont("helvetica", "bold");
    // doc.setTextColor(255, 0, 0);
    // doc.text(
    //   `Expected Date: ${formatDateToDDMMYYYY(order.karigar_delivery_date)}`,
    //   pageWidth / 2,
    //   contentY,
    //   { align: "center" }
    // );
    // doc.setTextColor(0, 0, 0);
    // contentY += 10;

    let images = [];
    try {
      images = JSON.parse(order.order_images || "[]");
    } catch {}

    let firstImage = true;

    for (const file of images) {
      if (isImageUrl(file)) {
        try {
          const base64 = await convertToCompressedBase64(file);
          const { width, height } = doc.getImageProperties(base64);

          const isPortrait = height >= width;
          let imgW, imgH;

          if (firstImage) {
            if (isPortrait) {
              imgH = 140;
              imgW = (imgH / height) * width;
            } else {
              imgW = 180;
              imgH = (imgW / width) * height;
            }
            doc.addImage(
              base64,
              "JPEG",
              (pageWidth - imgW) / 2,
              contentY,
              imgW,
              imgH,
            );
            contentY += imgH + 10;
            firstImage = false;
          } else {
            doc.addPage();
            if (isPortrait) {
              imgH = 180;
              imgW = (imgH / height) * width;
            } else {
              imgW = 180;
              imgH = (imgW / width) * height;
            }
            doc.addImage(
              base64,
              "JPEG",
              (pageWidth - imgW) / 2,
              (pageHeight - imgH) / 2,
              imgW,
              imgH,
            );
          }
        } catch (err) {
          console.warn("Failed to load image:", file, err);
        }
      }
    }

    const basePdfBytes = doc.output("arraybuffer");
    const mainPdf = await PDFDocument.load(basePdfBytes);

    for (const file of images) {
      if (isPdfUrl(file)) {
        try {
          const pdfBytes = await fetchPdfBytes(file);
          const externalPdf = await PDFDocument.load(pdfBytes);
          const copiedPages = await mainPdf.copyPages(
            externalPdf,
            externalPdf.getPageIndices(),
          );
          copiedPages.forEach((page) => mainPdf.addPage(page));
        } catch (err) {
          console.warn("Failed to load PDF:", file, err);
        }
      }
    }

    const finalBytes = await mainPdf.save();
    const blob = new Blob([finalBytes], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `order_${order.storeorderno || "download"}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(link.href);
  };

  return (
    <div className="order-details-page-custom">
      {jobcardItems.length > 0 && (
        <Button
          onClick={handleViewJobcard}
          variant="contained"
          fullWidth
          startIcon={<DownloadIcon sx={{ fontSize: 18 }} />}
          sx={{
            color: "#fff",
            backgroundColor: "#0A4A4D",
            fontWeight: 600,
            borderRadius: 2,
            my: { xs: 0.5, sm: 0.5 },
            width: 200,
            py: 1,
            fontSize: "0.8125rem",
            justifyContent: "flex-start",
            "& .MuiButton-startIcon": { marginRight: "6px" },
            "&:hover": { backgroundColor: "#0A4A4D" },
          }}
        >
          Print Stone Report
        </Button>
      )}

      {userRole === "MFR" && (
        <Button
          onClick={() => handleDownloadPdf(order)}
          variant="outlined"
          color="inherit"
          fullWidth
          startIcon={<DownloadIcon sx={{ fontSize: 18 }} />} // smaller icon if needed
          sx={{
            color: "#fdfdfdff",
            backgroundColor: "#0D7377",
            fontWeight: 600,
            borderRadius: 2,
            my: { xs: 0.5, sm: 0.5 },
            flex: 1,
            width: 200,
            py: 1,
            fontSize: "0.8125rem",
            borderColor: "#9e9e9e",
            justifyContent: "flex-start", // optional: aligns icon+text left inside button
            "& .MuiButton-startIcon": {
              marginRight: "6px", // adjust spacing between icon and text
            },
            "&:hover": {
              backgroundColor: "#0D7377",
              color: "#fff",
              borderColor: "#616161",
            },
          }}
        >
          Download Jobcard
        </Button>
      )}

      <div className="order-details-image-custom">
        <Box
          sx={{
            width: "100%",
            height: 400,
            borderRadius: 2,
            overflow: "hidden",
            mb: 2,
            border: "1px solid #ccc",
          }}
        >
          {selectedImage ? (
            (() => {
              const displayUrl =
                selectedImage?.preview || selectedImage?.url || selectedImage;

              const isVideo = /\.(mp4|webm|ogg)(\?.*)?$/i.test(displayUrl);
              const isPDF = /\.pdf(\?.*)?$/i.test(displayUrl);

              if (isVideo) {
                return (
                  <video
                    src={displayUrl}
                    controls
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      cursor: "pointer",
                    }}
                    // onClick={() => setImageModalOpen(true)}
                  />
                );
              } else if (isPDF) {
                return (
                  <iframe
                    src={displayUrl}
                    type="application/pdf"
                    style={{ width: "100%", height: "100%", border: "none" }}
                    title="PDF Preview"
                  />
                );
              } else {
                return (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      backgroundImage: `url("${displayUrl}")`,
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      cursor: "pointer",
                      transition: "transform 0.3s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                    onClick={() => handleImageClick(displayUrl)}
                  ></Box>
                );
              }
            })()
          ) : (
            <Typography variant="body2" align="center" mt={15}>
              No media selected
            </Typography>
          )}
        </Box>

        <Box sx={{ display: "flex", gap: 2, overflowX: "auto", p: 2 }}>
          {(() => {
            try {
              const media = JSON.parse(order?.order_images || "[]");

              return media.map((url, index) => {
                const isVideo = /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);
                const isPDF = /\.pdf(\?.*)?$/i.test(url);

                return (
                  <Box
                    key={index}
                    sx={{
                      width: 100,
                      height: 100,
                      cursor: "pointer",
                      flex: "0 0 auto",
                      border: "1px solid #474747",
                      borderRadius: 1,
                    }}
                    onClick={() => setSelectedImage({ url })}
                  >
                    {isVideo ? (
                      <video
                        src={url}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "4px",
                        }}
                        muted
                        loop
                        playsInline
                      />
                    ) : isPDF ? (
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          backgroundColor: "#f5f5f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "4px",
                          flexDirection: "column",
                          p: 1,
                        }}
                      >
                        <img
                          src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                          alt="PDF"
                          style={{ width: 30, height: 30 }}
                        />
                        <Typography variant="caption" sx={{ mt: 1 }}>
                          PDF
                        </Typography>
                      </Box>
                    ) : (
                      <img
                        src={url}
                        alt={`media-${index}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "4px",
                        }}
                        onError={() =>
                          console.error("Media failed to load:", url)
                        }
                      />
                    )}
                  </Box>
                );
              });
            } catch (error) {
              console.error("Error parsing media:", error);
              return null;
            }
          })()}
        </Box>
      </div>

      <div className="order-details-info-custom">
        <div className="order-details">
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#0A4A4D" }}
          >
            Basic Info
          </Typography>

          <Box sx={{ px: 2 }}>
            {order.itemtype_name && (
              <>
                <Typography
                  sx={{
                    fontSize: "14px !important",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ color: "#474747" }}>Item Type:</span>
                  <span style={{ fontWeight: 600, color: "#474747" }}>
                    {order.itemtype_name}
                  </span>
                </Typography>
                <Divider sx={{ borderColor: "#999" }} />
              </>
            )}

            {order.design_name && (
              <>
                <Typography
                  sx={{
                    fontSize: "14px !important",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ color: "#474747" }}>Design:</span>
                  <span style={{ fontWeight: 600, color: "#474747" }}>
                    {order.design_name}
                  </span>
                </Typography>
                <Divider sx={{ borderColor: "#999" }} />
              </>
            )}

            {order.pcs && (
              <>
                <Typography
                  sx={{
                    fontSize: "14px !important",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ color: "#474747" }}>Quantity:</span>
                  <span style={{ fontWeight: 600, color: "#474747" }}>
                    {order.pcs}
                  </span>
                </Typography>
                <Divider sx={{ borderColor: "#999" }} />
              </>
            )}

            {order.finishtype_name && (
              <>
                <Typography
                  sx={{
                    fontSize: "14px !important",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ color: "#474747" }}>Finish Type:</span>
                  <span style={{ fontWeight: 600, color: "#474747" }}>
                    {order.finishtype_name}
                  </span>
                </Typography>
                <Divider sx={{ borderColor: "#999" }} />
              </>
            )}

            {order.screw_type_name && (
              <Typography
                sx={{
                  fontSize: "14px !important",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ color: "#474747" }}>Screw Type:</span>
                <span style={{ fontWeight: 600, color: "#474747" }}>
                  {order.screw_type_name}
                </span>
              </Typography>
            )}
          </Box>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#0A4A4D" }}
          >
            Order Details
          </Typography>

          {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', p: 2 }}>
            <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
              {order.customer_name && userRole !== "Karigar" && (
                <Typography variant="body2" sx={{ color: '#474747' }}>Customer Name</Typography>
              )}
              {order.customer_order_number && userRole !== "Karigar" && (
                <Typography variant="body2" sx={{ color: '#474747' }}>
                  Customer Order ID
                </Typography>
              )}

              {order.storeorderno && (
                <Typography variant="body2" sx={{ color: '#474747' }}>Order ID</Typography>
              )}
              {order.store_name && userRole !== "Karigar" && (
                <Typography variant="body2" sx={{ color: '#474747' }}>Store Name</Typography>
              )}
              {order.orderdate && (
                <Typography variant="body2" sx={{ color: '#474747' }}>Order Date</Typography>
              )}
              {order.deliverydate && (
                <Typography variant="body2" sx={{ color: '#474747' }}>Deliver Date</Typography>
              )}

              {order.size_len && (
                <Typography variant="body2" sx={{ color: '#474747' }}>Size</Typography>
              )}

              {order.description && (
                <Typography variant="body2"  sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  gap: 1,
                  flexWrap: 'nowrap',
                  width: '100%',
                }}>Description</Typography>
              )}
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
              {order.customer_name && userRole !== "Karigar" && (
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#474747' }}>{order.customer_name}</Typography>
              )}
              {order.customer_order_number && userRole !== "Karigar" && (
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#474747' }}>{order.customer_order_number}</Typography>
              )}
              {order.storeorderno && (
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#474747' }}>{order.storeorderno}</Typography>
              )}
              {order.store_name && userRole !== "Karigar" && (
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#474747' }}>{order.store_name}</Typography>
              )}

              {order.orderdate && (
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#474747' }}>{order.orderdate}</Typography>
              )}
              {order.deliverydate && (
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#474747' }}>
                  {userRole === 'Karigar' ? order.karigar_delivery_date : order.deliverydate}
                </Typography>)}

              {order.size_len && (
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#474747' }}>{order.size_len}</Typography>
              )}
                 {order.description && (
                <Typography variant="body2"   
                 sx={{
                  flex: '1',
                  textAlign: 'right',
                  color: '#474747',
                  fontWeight: 'bold',
                  wordBreak: 'break-word',
                }}>{order.description}</Typography>
              )}
            </Box>
          </Box> */}

          <Box sx={{ px: 2, display: "flex", flexDirection: "column" }}>
            {order.customer_name && userRole !== "Karigar" && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      color: "#474747",
                      flex: 1,
                    }}
                  >
                    Customer Name
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      fontWeight: "bold",
                      color: "#474747",
                      textAlign: "right",
                    }}
                  >
                    {order.customer_name}
                  </Typography>
                </Box>
                <Divider sx={{ borderColor: "#888" }} />
              </>
            )}

            {order.customer_order_number && userRole !== "Karigar" && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      color: "#474747",
                      flex: 1,
                    }}
                  >
                    Customer Order ID
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      fontWeight: "bold",
                      color: "#474747",
                      textAlign: "right",
                    }}
                  >
                    {order.customer_order_number}
                  </Typography>
                </Box>
                <Divider sx={{ borderColor: "#888" }} />
              </>
            )}

            {order.storeorderno && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      color: "#474747",
                      flex: 1,
                    }}
                  >
                    Order ID
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      fontWeight: "bold",
                      color: "#474747",
                      textAlign: "right",
                    }}
                  >
                    {order.storeorderno}
                  </Typography>
                </Box>
                <Divider sx={{ borderColor: "#888" }} />
              </>
            )}

            {order.store_name && userRole !== "Karigar" && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      color: "#474747",
                      flex: 1,
                    }}
                  >
                    Store Name
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      fontWeight: "bold",
                      color: "#474747",
                      textAlign: "right",
                    }}
                  >
                    {order.store_name}
                  </Typography>
                </Box>
                <Divider sx={{ borderColor: "#888" }} />
              </>
            )}

            {order.orderdate && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      color: "#474747",
                      flex: 1,
                    }}
                  >
                    Order Date
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      fontWeight: "bold",
                      color: "#474747",
                      textAlign: "right",
                    }}
                  >
                    {order.orderdate}
                  </Typography>
                </Box>
                <Divider sx={{ borderColor: "#888" }} />
              </>
            )}

            {order.deliverydate && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      color: "#474747",
                      flex: 1,
                    }}
                  >
                    Deliver Date
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      fontWeight: "bold",
                      color: "#474747",
                      textAlign: "right",
                    }}
                  >
                    {userRole === "Karigar"
                      ? order.karigar_delivery_date
                      : order.deliverydate}
                  </Typography>
                </Box>
                <Divider sx={{ borderColor: "#888" }} />
              </>
            )}

            {order.size_len && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      color: "#474747",
                      flex: 1,
                    }}
                  >
                    Size
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px !important",
                      fontWeight: "bold",
                      color: "#474747",
                      textAlign: "right",
                    }}
                  >
                    {order.size_len}
                  </Typography>
                </Box>
                <Divider sx={{ borderColor: "#888" }} />
              </>
            )}

            {order.description && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start", // ensures top alignment if value wraps
                    gap: 2,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#474747",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Description
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "red",
                      textAlign: "right",
                      maxWidth: "70%", // or adjust as needed
                      wordBreak: "break-word",
                    }}
                  >
                    {order.description || "-"}
                  </Typography>
                </Box>
              </>
            )}
          </Box>

          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#0A4A4D" }}
          >
            Specification
          </Typography>

          <Box sx={{ px: 2 }}>
            {order.weight && (
              <>
                <Typography
                  sx={{
                    fontSize: "14px !important",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ color: "#474747" }}>Gross Wt:</span>
                  <span style={{ fontWeight: 600, color: "#474747" }}>
                    {Number(order.weight).toFixed(3)}
                  </span>
                </Typography>
                <Divider sx={{ borderColor: "#888" }} />
              </>
            )}

            {order.netwt && (
              <>
                <Typography
                  sx={{
                    fontSize: "14px !important",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ color: "#474747" }}>Net Wt:</span>
                  <span style={{ fontWeight: 600, color: "#474747" }}>
                    {Number(order.netwt).toFixed(3)}
                  </span>
                </Typography>
                <Divider sx={{ borderColor: "#888" }} />
              </>
            )}

            {order.wt_range && (
              <>
                <Typography
                  sx={{
                    fontSize: "14px !important",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ color: "#474747" }}>Weight Range:</span>
                  <span style={{ fontWeight: 600, color: "#474747" }}>
                    {order.wt_range}
                  </span>
                </Typography>
                <Divider sx={{ borderColor: "#888" }} />
              </>
            )}
          </Box>

          {(userRole === "MFR" || userRole === "COMFR") && (
            <>
              {" "}
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#0A4A4D" }}
              >
                Karigar Information
              </Typography>
              <Box sx={{ px: 2 }}>
                {order.karigar_name && (
                  <>
                    <Typography
                      sx={{
                        fontSize: "14px !important",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "#474747" }}>Name:</span>
                      <span style={{ fontWeight: 600, color: "#474747" }}>
                        {order.karigar_name}
                      </span>
                    </Typography>
                    <Divider sx={{ borderColor: "#888" }} />
                  </>
                )}

                {order.karigar_mobile && (
                  <>
                    <Typography
                      sx={{
                        fontSize: "14px !important",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "#474747" }}>Mobile:</span>
                      <span style={{ fontWeight: 600, color: "#474747" }}>
                        {order.karigar_mobile}
                      </span>
                    </Typography>
                    <Divider sx={{ borderColor: "#888" }} />
                  </>
                )}

                {order.karigar_delivery_date && (
                  <>
                    <Typography
                      sx={{
                        fontSize: "14px !important",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "#474747" }}>
                        Karigar Delivery Date:
                      </span>
                      <span style={{ fontWeight: 600, color: "#474747" }}>
                        {order.karigar_delivery_date}
                      </span>
                    </Typography>
                    <Divider sx={{ borderColor: "#888" }} />
                  </>
                )}
              </Box>
            </>
          )}

          {/* 
          {order.storeorderno && <p><strong>Order No:</strong> {order.storeorderno}</p>}
          {userRole !== 'Karigar' && order.store_name && <p><strong>Store Name:</strong> {order.store_name}</p>}
          {order.customer_order_number && <p><strong>Cust Order No:</strong> {order.customer_order_number}</p>}
          {(userRole === 'Karigar' && order.karigar_delivery_date) || order.deliverydate ? (
            <p>
              <strong>Delivery Date:</strong>
              {userRole === 'Karigar' ? order.karigar_delivery_date : order.deliverydate}
            </p>
          ) : null}
          {order.itemtype_name && <p><strong>Item Type:</strong> {order.itemtype_name}</p>}
          {order.design_name && <p><strong>Design Type:</strong> {order.design_name}</p>}
          {order.pcs && <p><strong>Quantity:</strong> {order.pcs}</p>}
          {order.weight && <p><strong>Gross Weight:</strong> {order.weight}</p>}
          {order.netwt && <p><strong>Netwt:</strong> {order.netwt}</p>}
          {order.size_len && <p><strong>Size Length:</strong> {order.size_len}</p>}
          {order.screw_type_name && <p><strong>Screw Type:</strong> {order.screw_type_name}</p>}
          {order.finishtype_name && <p><strong>Finish Type:</strong> {order.finishtype_name}</p>}
          {order.description && <p><strong>Description:</strong> {order.description}</p>}
          {order.wt_range && <p><strong>Weight Range:</strong> {order.wt_range}</p>}
          {order.rejection_message && <p><strong>Rejection Message:</strong> {order.rejection_message}</p>}
          {userRole === 'MFR' && order.karigar_name && <p><strong>Karigar Name:</strong> {order.karigar_name}</p>}
          {userRole === 'MFR' && order.karigar_mobile && <p><strong>Karigar Mobile:</strong> {order.karigar_mobile}</p>}
          {userRole === 'MFR' && order.karigar_delivery_date && <p><strong>K-Delivery Date:</strong> {order.karigar_delivery_date}</p>} */}
        </div>

        {userRole === "MFR" ||
          (userRole === "SUPERADMIN" && (
            <Button
              variant="contained"
              color="#0D7377"
              onClick={handleEditOrder}
            >
              Edit Order
            </Button>
          ))}

        {userRole === "Karigar" && order.work_status_id == "3" && (
          <div className="order-details-actions-custom">
            <button
              className="order-details-accept-btn-custom"
              onClick={handleAccept}
            >
              Accept
            </button>
            <button
              className="order-details-reject-btn-custom"
              onClick={handleReject}
            >
              Reject
            </button>
          </div>
        )}

        {userRole === "Karigar" &&
          order.work_status_id == "4" &&
          orderImages.length > 0 && (
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0D7377",
                "&:hover": { backgroundColor: "#0A5C60" },
              }}
              onClick={handleDownloadAll}
            >
              Download All Images/Videos
            </Button>
          )}

        {userRole === "Karigar" &&
          (order.work_status_id == "4" || order.work_status_id == "8") && (
            <div className="order-details-actions-custom">
              <StyledFormControl variant="outlined">
                {" "}
                {/* Use StyledFormControl */}
                <Select
                  labelId="completion-status-label" // Connect label and select
                  id="completion-status-select"
                  value={completionStatus}
                  onChange={handleCompletionStatusChange}
                  label="Status" // Label for the Select component
                >
                  <MenuItem value="complete">Completed</MenuItem>

                  <MenuItem
                    disabled={order.work_status_id == "8"}
                    value="partial"
                  >
                    Partially Completed
                  </MenuItem>
                  <MenuItem
                    disabled={order.work_status_id == "8"}
                    value="completewithoutqr"
                  >
                    Complete without QR
                  </MenuItem>

                  {/* Add more options if needed */}
                </Select>
              </StyledFormControl>
              <button
                className="order-details-accept-btn-custom"
                onClick={handleComplete}
              >
                NEXT
              </button>
            </div>
          )}
      </div>

      {/* Modal for editing order */}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent>
          <h3>Edit Order</h3>

          {/* Form for editing */}
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Order ID"
                value={editableOrder.storeorderno || ""}
                fullWidth
                disabled
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Order Date"
                type="date"
                value={editableOrder.orderdate || ""}
                fullWidth
                onChange={(e) =>
                  setEditableOrder({
                    ...editableOrder,
                    orderdate: e.target.value,
                  })
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Delivery Date"
                type="date"
                value={editableOrder.deliverydate || ""}
                fullWidth
                onChange={(e) =>
                  setEditableOrder({
                    ...editableOrder,
                    deliverydate: e.target.value,
                  })
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="karigar Delivery Date"
                type="date"
                value={editableOrder.karigar_delivery_date || ""}
                fullWidth
                onChange={(e) =>
                  setEditableOrder({
                    ...editableOrder,
                    karigar_delivery_date: e.target.value,
                  })
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Customer Order No"
                value={editableOrder.customer_order_number || ""}
                fullWidth
                onChange={(e) =>
                  setEditableOrder({
                    ...editableOrder,
                    customer_order_number: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Customer Name"
                value={editableOrder.customer_name || ""}
                fullWidth
                onChange={(e) =>
                  setEditableOrder({
                    ...editableOrder,
                    customer_name: e.target.value,
                  })
                }
              />
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Item Type</InputLabel>
                <Select
                  value={selectedItemTypeId}
                  onChange={(e) => {
                    const newSelectedItemTypeId = e.target.value;
                    setselectedItemTypeId(newSelectedItemTypeId);
                    setselectedDesignId(""); // Reset the design when item type changes
                  }}
                  label="Item Type"
                >
                  {storeData?.itemtypes?.map((itemType) => (
                    <MenuItem key={itemType.id} value={itemType.id}>
                      {itemType.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Design</InputLabel>
                <Select
                  value={selectedDesignId}
                  onChange={(e) => setselectedDesignId(e.target.value)}
                  label="Design"
                  disabled={!selectedItemTypeId} // Disable if no Item Type is selected
                >
                  {storeData?.designs
                    ?.filter(
                      (design) => design.itemtype_id === selectedItemTypeId,
                    ) // Filter designs based on selected Item Type
                    .map((design) => (
                      <MenuItem key={design.id} value={design.id}>
                        {design.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Gross Weight"
                value={editableOrder.weight || ""}
                fullWidth
                onChange={(e) =>
                  setEditableOrder({ ...editableOrder, weight: e.target.value })
                }
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Net Weight"
                value={editableOrder.netwt || ""}
                fullWidth
                onChange={(e) =>
                  setEditableOrder({ ...editableOrder, netwt: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Quantity (PCS)"
                value={editableOrder.pcs || ""}
                fullWidth
                onChange={(e) =>
                  setEditableOrder({ ...editableOrder, pcs: e.target.value })
                }
              />
            </Grid>

            <Grid item>
              <TextField
                label="Description"
                value={editableOrder.description || ""}
                fullWidth
                rows={4}
                multiline
                onChange={(e) =>
                  setEditableOrder({
                    ...editableOrder,
                    description: e.target.value,
                  })
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Sample Weight"
                value={editableOrder.sample_weight || ""}
                fullWidth
                onChange={(e) =>
                  setEditableOrder({
                    ...editableOrder,
                    sample_weight: e.target.value,
                  })
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="semi finished Weight"
                value={editableOrder.semifinishedwt || ""}
                fullWidth
                onChange={(e) =>
                  setEditableOrder({
                    ...editableOrder,
                    semifinishedwt: e.target.value,
                  })
                }
              />
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Assign Karigar</InputLabel>
                <Select
                  value={selectedKarigar}
                  onChange={(e) => setSelectedKarigar(e.target.value)}
                  label="Assign Karigar"
                >
                  {storeData?.karigars?.map((karigar) => (
                    <MenuItem key={karigar.id} value={karigar.id}>
                      {karigar.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Size/Length"
                value={editableOrder.size_len || ""}
                fullWidth
                onChange={(e) =>
                  setEditableOrder({
                    ...editableOrder,
                    size_len: e.target.value,
                  })
                }
              />
            </Grid>

            {/* Dropdowns for editable fields */}
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Work Status</InputLabel>
                <Select
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  label="Work Status"
                >
                  {storeData?.allstatus
                    ?.filter(
                      (status) => userRole === "SUPERADMIN" || status.id !== 5,
                    )
                    .map((status) => (
                      <MenuItem key={status.id} value={status.id}>
                        {status.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            {(userRole === "MFR" || userRole === "COMFR") && (
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel>Store Name</InputLabel>
                  <Select
                    value={selectedCustmerId}
                    onChange={(e) => setselectedCustmerId(e.target.value)}
                    label="Store Name"
                  >
                    {storeData?.mfrstore?.map((status) => (
                      <MenuItem key={status.id} value={status.id}>
                        {status.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {userRole === "SUPERADMIN" && (
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel>Store Name</InputLabel>
                  <Select
                    value={selectedCustmerId}
                    onChange={(e) => setselectedCustmerId(e.target.value)}
                    label="Store Name"
                  >
                    {storeData?.customers?.map((status) => (
                      <MenuItem key={status.id} value={status.id}>
                        {status.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Screw Type</InputLabel>
                <Select
                  value={selectedScrewTypeId}
                  onChange={(e) => setselectedScrewTypeId(e.target.value)}
                  label="Screw Type"
                >
                  {storeData?.screwTypes?.map((status) => (
                    <MenuItem key={status.id} value={status.id}>
                      {status.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Color</InputLabel>
                <Select
                  value={selectedFinishId}
                  onChange={(e) => setselectedFinishId(e.target.value)}
                  label="Color"
                >
                  {storeData?.finishtypes?.map((status) => (
                    <MenuItem key={status.id} value={status.id}>
                      {status.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item>
              <TextField
                label="Weight Range"
                className="grid-item-full"
                value={editableOrder.wt_range || ""}
                fullWidth
                rows={4}
                multiline
                onChange={(e) =>
                  setEditableOrder({
                    ...editableOrder,
                    wt_range: e.target.value,
                  })
                }
              />
            </Grid>

            {/* <div className="grid-item" {...getRootProps()}>
              <input {...getInputProps()} />
              <Button variant="outlined" component="span">
                Upload Image
              </Button>
            </div> */}

            <div className="image-submit-container">
              {/* Check if order_images is a string (JSON) and parse it */}
              {editableOrder.order_images &&
              typeof editableOrder.order_images === "string" ? (
                (() => {
                  let mediaFiles = [];
                  try {
                    mediaFiles = JSON.parse(editableOrder.order_images); // Parse the JSON string
                  } catch (e) {
                    console.error("Error parsing media files:", e);
                  }

                  // Check if parsed mediaFiles is an array
                  if (Array.isArray(mediaFiles)) {
                    return mediaFiles.map((media, index) => {
                      // Check if the media is an image
                      if (media.match(/\.(jpeg|jpg|png|gif|webp)$/)) {
                        return (
                          <div className="image-preview" key={index}>
                            <img
                              src={media}
                              alt={`Order Preview ${index}`}
                              style={{
                                width: "100%",
                                maxHeight: "300px",
                                objectFit: "contain",
                                marginTop: "10px",
                              }}
                            />
                          </div>
                        );
                      }

                      // Check if the media is a video
                      if (media.match(/\.(mp4|webm|ogg)$/)) {
                        return (
                          <div className="image-preview" key={index}>
                            <video
                              controls
                              style={{
                                width: "100%",
                                maxHeight: "300px",
                                objectFit: "contain",
                                marginTop: "10px",
                              }}
                            >
                              <source src={media} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        );
                      }

                      return null;
                    });
                  }
                  return (
                    <Typography color="textSecondary">
                      No media uploaded.
                    </Typography>
                  );
                })()
              ) : (
                // If it's a single image or video (non-array)
                <>
                  {/* Preview uploaded file (if it's a File instance) */}
                  {editableOrder.order_images instanceof File ? (
                    <div className="image-preview">
                      <Typography variant="body1">Image Preview:</Typography>
                      <img
                        src={URL.createObjectURL(editableOrder.order_images)}
                        alt="Uploaded Preview"
                        style={{
                          width: "100%",
                          maxHeight: "300px",
                          objectFit: "contain",
                          marginTop: "10px",
                        }}
                      />
                    </div>
                  ) : (
                    // Preview existing image from URL (if it's a string URL)
                    editableOrder.order_images && (
                      <div className="image-preview">
                        <img
                          src={editableOrder.order_images}
                          alt="Existing Image"
                          style={{
                            width: "100%",
                            maxHeight: "300px",
                            objectFit: "contain",
                            marginTop: "10px",
                          }}
                        />
                      </div>
                    )
                  )}
                </>
              )}
            </div>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSaveChanges} color="primary">
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={imageModalOpen}
        onClose={handleCloseImageModal}
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <img
            src={selectedImage}
            alt="full view"
            style={{
              width: "100%",
              maxHeight: "80vh",
              objectFit: "contain",
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImageModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={rejectModalOpen} onClose={handleCloseRejectModal}>
        <DialogContent>
          <TextField
            label="Reason for Rejection"
            fullWidth
            multiline
            rows={6}
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRejectModal} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleConfirmReject} color="primary">
            Confirm Reject
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4474747}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        sx={{
          "&.MuiSnackbar-root": {
            bottom: "100px !important", // force override snackbar position
          },
        }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{
            width: "100%",
            backgroundColor:
              snackbar.severity === "success" ? "#4caf50" : "#f44336", // Example based on severity
            color: "#fff", // Ensure text is visible
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)", // Add shadow for effect
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default OrderDetails;
